import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchCaseStudies } from '@/lib/api';

export default function ResultsSection() {
  const [studies, setStudies] = useState([]);
  useEffect(() => {
    fetchCaseStudies().then(setStudies).catch(() => {});
  }, []);

  return (
    <section className="py-12 lg:py-16 bg-[#262626] relative overflow-hidden" id="results" data-testid="results-section">
      <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360">
        <div className="highlights-kicker text-white">
          <span />VERIFIED RESULTS
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em]">
            Real Brands. <span className="accent">Real</span> Numbers.
          </h2>
          <div className="lg:col-span-5">
            <div className='reveal-on-scroll'>
               <p className="leading-relaxed sec-subhead text-white mb-4">
              Performance benchmarks built on campaigns where every click, lead, and conversion is directly connected to verified revenue growth — never inflated by meaningless vanity traffic metrics.
            </p>
            <Link to="/case-studies" className="btn btn-outline" data-testid="view-all-studies">
              View all studies →
            </Link>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0  border-l border-[#5a5a5a] mt-8">
          {studies.map((s) => (
            <Link
              to={`/case-studies/${s.slug}`}
              key={s.slug}
              className="p-4 lg:p-8 border border-l-0 border-[#5a5a5a] bg-black/30 hover:bg-[#0b0b0b] transition-colors group flex flex-col h-full"
              data-testid={`home-study-${s.slug}`}
            >
              <div className="font-mono  text-[14px] font-bold text-blue mb-2">{s.industry.toUpperCase()}</div>
              <div className="font-display text-[28px] font-bold mb-4">{s.brand}</div>
              <div className="grid grid-cols-3 gap-2 mb-5">
                {s.metrics.map((m, i) => (
                  <div key={i}>
                    <div className="text-green font-display text-[24px] font-extrabold leading-none">{m.value}</div>
                    <div className="text-[10px] lg:text-[11px] font-medium uppercase tracking-wider mt-2">{m.label}</div>
                  </div>
                ))}
              </div>
              <p className="text-[14px] text-[#9a9a9a] leading-relaxed mb-3 lg:mb-5">{s.summary}</p>
              <div className="mt-auto font-mono text-[14px] font-semibold accent group-hover:translate-x-1 transition-transform">READ FULL STUDY →</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
